import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { ButtonGroup, Button, pxToRem } from '@modernhealth/vital-components';

interface Props {
    backText?: string;
    forwardText?: string;
    onBackClick: () => void;
    onForwardClick: () => void;
}

const ButtonContainer = styled.div({
    marginTop: pxToRem(24),
});

export const CommonStepButtons: React.FC<Props> = ({
    backText,
    forwardText,
    onBackClick,
    onForwardClick,
}) => {
    const { t } = useTranslation();

    return (
        <ButtonContainer>
            <ButtonGroup>
                <Button onClick={onBackClick}>
                    {backText || t('intakeForms:step_buttons.back')}
                </Button>
                <Button onClick={onForwardClick}>
                    {forwardText || t('intakeForms:step_buttons.forward')}
                </Button>
            </ButtonGroup>
        </ButtonContainer>
    );
};
